import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';

// 8 characters where the second will sometimes be a letter and the last is always a letter
const re = /^.*[0-9]{1}([0-9]{1}|[a-zA-Z]{1})[0-9]{5}[a-zA-Z]{1}.*$/;
// const re = /^.*[0-9]{7}([a-zA-Z]{2}|[a-zA-Z]{1})*$/;

export function VatValidator(): ValidatorFn {
  return (fc: FormControl): ValidationErrors | null => {
    const isValid = fc.value && re.test(fc.value);
    if (isValid) {
      return null;
    } else {
      return { [FORM_ERRORS.VAT]: true };
    }
  };
}
